import {
  FlowAccordion as DSFlowAccordion,
  PropsFlowAccordion,
  PropsFlowAccordionG4P,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../intl";

export function FlowAccordion(
  props: PropsFlowAccordion | PropsFlowAccordionG4P
) {
  const formatMessage = useFormatMessage();
  return (
    <DSFlowAccordion
      expandedAriaLabel={formatMessage(
        "generic.flowAccordion.expand.ariaLabel"
      )}
      collapsedAriaLabel={formatMessage(
        "generic.flowAccordion.collapse.ariaLabel"
      )}
      {...props}
    />
  );
}
